import React from 'react';
import Hero from '../components/Hero';
import ProductPortfolio from '../components/ProductPortfolio';
import WhyChooseUs from '../components/WhyChooseUs';
import CertificationGallery from '../components/CertificationGallery';
import ClientSlider from '../components/ClientSlider';

const Home = () => {
    return (
        <>
            <Hero />
            <ProductPortfolio />
            <WhyChooseUs />
            <CertificationGallery />
            <ClientSlider />
        </>
    );
};
export default Home;